import React, { useState } from "react";
import { Routes, Route, Link, Navigate } from "react-router-dom";
import Users from "./components/users/Users";
import Promocode from "./components/promocode/Promocode";
import Login from "./components/login/Login";
import VoiceChat from "./components/voiceagent/VoiceAgent";
import VectorStoreAdmin from "./components/vectorStore/vectorStore";
import RealEstateAnalysis from "./components/realEstate/RealEstateAnalysis";
import LegalPayments from "./components/legalPayments/LegalPayments";
import LegalMcp from "./components/legalMcp/LegalMcp";
import LocalAdvanceReport from "./components/advanceReport/LocalAdvanceReport";
import OneCApiKeys from "./components/oneCApiKeys/OneCApiKeys";

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  return (
    <div>
      {isAuthenticated ? (
        <>
          <nav>
            <span style={{ position: 'absolute', color: 'grey', right: '10px' }}>v3</span>
            <ul>
              <li><Link to="/users">Пользователи</Link></li>
              <li><Link to="/promocode">Промокоды</Link></li>
              <li><Link to="/legal-payments">Юр. лица</Link></li>
              <li><Link to="/voiceagent">Агент</Link></li>
              <li><Link to="/vectorStore"> vectorStore </Link></li>
              <li><Link to="/legal-mcp">Legal MCP</Link></li>
              <li><Link to="/RealEstateAnalysis">RealEstateAnalysis</Link></li>
              <li><Link to="/advance-report-local">Advance Report · Local AI</Link></li>
              <li><Link to="/one-c-api-keys">1C API</Link></li>
              <li><button onClick={() => setIsAuthenticated(false)}>Выйти</button></li>
            </ul>
          </nav>

          <Routes>
            <Route path="/users" element={<Users />} />
            <Route path="/promocode" element={<Promocode />} />
            <Route path="/legal-payments" element={<LegalPayments />} />
            <Route path="/voiceagent" element={<VoiceChat />} />
            <Route path="/vectorStore" element={<VectorStoreAdmin />} />
            <Route path="/legal-mcp" element={<LegalMcp />} />
            <Route path="/advance-report-local" element={<LocalAdvanceReport />} />
            <Route path="/one-c-api-keys" element={<OneCApiKeys />} />
            <Route path="*" element={<Navigate to="/users" />} />
            <Route path="/RealEstateAnalysis" element={<RealEstateAnalysis />} />
          </Routes>
        </>
      ) : (
        <Login onLoginSuccess={() => setIsAuthenticated(true)} />
      )}
    </div>
  );
}

export default App;
